<template>
  <UploadLi
    :icon="pcImg"
    nameText="电脑上传"
    nameTip="需要电脑、税盘"
    @upload="upload"
    v-bind="$attrs"
  />
</template>

<script>
import pcImg from '@/assets/images/pc.png';
import UploadLi from './UploadLi.vue';

export default {
  name: 'PcUpload',
  props: {
    isUpload: {
      type: Boolean,
    },
  },
  components: {
    UploadLi,
  },
  data() {
    return {
      pcImg,
    };
  },
  methods: {
    // 弹窗电脑上传步骤
    upload() {
      console.log(this.isUpload, '==isUpload');
      if (!this.isUpload) {
        this.$toast('该产品不支持“电脑上传“，请选择“手机上传”');
        return;
      }
      window.location.href = 'https://mp.weixin.qq.com/s/Kkx8IVZeR-2F8qukR8zdEw';
    },
  },
};
</script>
<style scoped lang="scss">
</style>
